module.exports = __webpack_public_path__ + "media/brands/kymco-017acc29.png";